export enum HISTORY_EVENTS {
  ATTEMPTED = 'attempt',
  CANCEL = 'cancel',
  CHANGE = 'change',
  COMPLETED = 'completed',
  CREATE = 'create',
  DECLINE = 'decline',
  MANUAL_CREATE = 'manual create',
  REOPEN = 'reopen',
  RESCHEDULE = 'reschedule',
  SCHEDULE = 'schedule',
  UPDATE = 'update',
  VIEWED = 'profile viewed',
}

export enum CHANGE_TYPE {
  EMAIL = 'email',
  PHONE = 'phone',
}

export interface PatientHistory {
  appointmentHistoryID: string;
  appointmentID: string;
  changeType: CHANGE_TYPE | string;
  curAppointmentEndTime: string;
  curAppointmentID: string;
  curAppointmentStartTime: string;
  curAppointmentTimezone: string;
  curChange: string;
  declineNote: string;
  declineReasonCode: string;
  event: HISTORY_EVENTS;
  eventTimestamp: string;
  interpretationID: string;
  performer: string;
  prevAppointmentEndTime: string;
  prevAppointmentID: string;
  prevAppointmentStartTime: string;
  prevAppointmentTimezone: string;
  prevChange: string;
  sourceID: string;
  userID: string;
}
